import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

import { genders as ALL_GENDERS } from '../../quotes/constants';

// The BE names the keys in this order in the product config
const defaultOrder = ['Men', 'Women', 'Kids'];

function sortByDefaultOrder(selectedGenders) {
  return sortBy(selectedGenders, gender => defaultOrder.indexOf(gender));
}

function getDefaultShare(product, selectedGenders, gender) {
  const splitKey = sortByDefaultOrder(selectedGenders)
    .map(_ => _.toLowerCase())
    .join('_');
  return get(
    product,
    ['genderSplitRule', `${splitKey}_${gender.toUpperCase()}`],
    0,
  );
}

const getZeroSharesObj = () =>
  ALL_GENDERS.reduce(
    (acc, { value }) => ({
      ...acc,
      [`gender${value}Share`]: 0,
    }),
    {},
  );

// eslint-disable-next-line import/prefer-default-export
export function getDefaultGenderShare(product, selectedGenders = []) {
  if (selectedGenders.length === 0) {
    return getZeroSharesObj();
  }

  if (selectedGenders.length === 1) {
    return { ...getZeroSharesObj(), [`gender${selectedGenders[0]}Share`]: 1 };
  }

  return ALL_GENDERS.reduce(
    (acc, { value }) => ({
      ...acc,
      [`gender${value}Share`]: getDefaultShare(product, selectedGenders, value),
    }),
    {},
  );
}
